var map = {
	"./bitbucket.svg": 80313,
	"./chevron-right.svg": 68914,
	"./circle.svg": 99690,
	"./close.svg": 96734,
	"./code.svg": 49305,
	"./database.svg": 40233,
	"./donut.svg": 85626,
	"./external.svg": 79359,
	"./eye-strikethrough.svg": 70695,
	"./eye.svg": 13997,
	"./git.svg": 5162,
	"./github.svg": 54591,
	"./gitlab.svg": 56319,
	"./graphql.svg": 38641,
	"./menu.svg": 49907,
	"./organization.svg": 56163,
	"./packages.svg": 13053,
	"./password.svg": 55545,
	"./permission-small-cross.svg": 42582,
	"./permission-small-tick.svg": 44237,
	"./placeholder.svg": 26801,
	"./plus-circle.svg": 6803,
	"./plus.svg": 90358,
	"./queues.svg": 91538,
	"./retry.svg": 4876,
	"./unknown-user.svg": 6480,
	"./webhook.svg": 19933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58065;